import productInstance from './instance'

const storeProduct = (data) => {
	return productInstance.post('/products/', data)
}

export default storeProduct
